<template>
  <div>
    <b-card-title class="mb-3">Time Zone</b-card-title>
    <b-form-select
        :options="timeZoneList"
        v-model="selectedTimeFormat"
        class="mb-3"
        @change="onChangeTimeFormat"
        value-field="value"
        text-field="text"
    ></b-form-select>
  </div>
</template>

<script>
import TIME_ZONE_LIST from "@/core/config/time.zone.json";
import _ from 'lodash';
import axios from "axios";
const getCountryISO3 = require("country-iso-2-to-3");


export default {
  name: 'TimeFormatSelector',
  data() {
    return {
      selectedTimeFormat: this.$store.getters.getSelectedLang ? this.$store.getters.getSelectedLang.value : 'en-US',
      timeFormat: this.$store.getters.getSelectedLang,
      timeZoneList: TIME_ZONE_LIST,
      iso3Code : null
    }
  },
  async mounted() {
    const getTimeZone = await this.$store.dispatch('getTimeZone');

    if (getTimeZone.message === "timezone is not defined.") {
      const ip = await axios("https://test-api.argoskyc.com/dev/ipInfo" , {
        method : 'GET'
      });

      this.iso3Code = getCountryISO3(ip.data.country);
    }

    await this.onChangeTimeFormat();
    const timeZone = await this.$store.dispatch('getTimeZone');

    if (timeZone.statusCode === 200) {
      const timeFormat = TIME_ZONE_LIST.find( item => item.timezone === timeZone.timezone );
      timeFormat.utc = this.getUTCDifference( timeZone.timezone );
      await this.$store.dispatch('setSelectedLanguage', timeFormat);
    }
  },
  methods: {
    getUTCDifference( timezone ) {
      const date = new Date();
      let localTime = new Date(date.toLocaleString('en-US', {timeZone: timezone}));
      let utcTime = new Date(date.toLocaleString('en-US', {timeZone: 'UTC'}));
      const utc = (localTime - utcTime) / (1000*60*60);
      return `${utc > 0 ? '+' : ''}${utc}`
    },
    async onChangeTimeFormat() {
      const timeFormat = TIME_ZONE_LIST.find( item => item.value === this.selectedTimeFormat );
      timeFormat.utc = this.getUTCDifference( timeFormat.timezone );

      if (this.iso3Code) {
        timeFormat.issuingCountry = this.iso3Code;
      }



      if (this.$store.getters.currentLoginUser?.phoneNumber) {
        timeFormat.phoneNumber = this.$store.getters.currentLoginUser?.phoneNumber;
      }

      await this.$store.dispatch( 'setSelectedLanguage' , timeFormat );
      await this.$store.dispatch('setTimeZone' , timeFormat);
      localStorage.setItem('tz', timeFormat.timezone)
      this.iso3Code = null;
    },
    async translateCountryListText(){
      const deepCopy = _.cloneDeep(TIME_ZONE_LIST);
      this.timeZoneList = deepCopy.map( item => {
        const utcDifference = this.getUTCDifference( item.timezone );

        item.text = `${this.$t(item.text)} (UTC${utcDifference})`;
        return item;
      });
    },

  },
  async created() {
    await this.translateCountryListText();

  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.translateCountryListText();
      }
    }
  }
}
</script>
